var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"service-block",class:{ wide: _vm.wide },style:({ backgroundImage: `url('/assets/images/landing/tabs/${_vm.background}.svg')` }),attrs:{"href":_vm.link}},[_c('div',{staticClass:"service-block-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"service-block-description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }